var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.list&&_vm.list.title)?_c('Tnode',{attrs:{"checkedIndex":_vm.checkedIndex,"dataKey":_vm.dataKey,"list":_vm.list},on:{"select":_vm._select}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }